import { defineStore } from 'pinia'

type PageSeoLayout = {
  title?: string
  description?: string
}

export const useSeoStore = defineStore('seo', () => {
  const { t } = useI18n()
  const router = useRouter()

  const pagesSeo = ref<{ route: string, seo: { layout: PageSeoLayout } }[]>([])

  const loadPagesForSeo = () => {
    pagesSeo.value = router.getRoutes().filter(el => { if (el.name?.toString().includes('en-us')) return el }).map(el => {
      const key = el.path
      const layout = {
        title: t(`seo.layouts.${key}.title`),
        description: t(`seo.layouts.${key}.description`)
      }
      return { route: key, seo: { layout } }
    })
  }


  return {
    pagesSeo,
    loadPagesForSeo
  }
})
